import { useEffect, useState } from "react";
import { Form, DrawerProps, Drawer, Row, Col } from "antd";
import { updateRecord, ChangeAdminPassword } from "../../utils/slice";
import { validateFields } from "../../../../../config/Global";
import SVGIcon from "../../../../../utils/SVGIcon";
import Config from "../../../../../config/Config";
import CancelButton from "../../../../../components/Buttons/CancelButton";
import SaveButton from "../../../../../components/Buttons/SaveButton";
import FormComponent from "./FormComponent";
import { assignErrorToInput } from "../../../../../store/api";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../utils/hooks/hooks";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";

interface ViewDrawerProps extends DrawerProps {
  titleName: string;
  open: boolean;
  close: () => void;
}

/**
 * Renders a drawer component for viewing details of a skill Portrait result of a user.
 *
 * @param {ViewDrawerProps} props - The props object containing the following properties:
 *   - titleName: The name of the title for the drawer.
 *   - open: A boolean indicating whether the drawer is open or not.
 *   - close: A function to close the drawer.
 *   - rest: Any additional props to be spread onto the Drawer component.
 * @return {JSX.Element} The rendered ViewSkillAssessmentDrawer component.
 */
const ChangePasswordDrawer: React.FC<ViewDrawerProps> = ({
  titleName,
  open,
  close,
  ...rest
}) => {
  const dispatch = useAppDispatch();
  const details = useAppSelector(state => state.user.changePasswordDetails);
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);

  const drawerClose = () => {
    close();
    form.resetFields();
    setDisabled(true)
  };

  // validate form fields and enable/disable save button based on the result
  const validateForm = () => {
    validateFields(form, setDisabled);
  };





  // handle form submission
  const onFinish = (data: any) => {
    if (details != null && details?.id) {

      setSaving(true);
      const req = {
        user_id: details.id,
        password: data.password
      }
      dispatch(ChangeAdminPassword(req))
        .then(() => {
          drawerClose();
        })
        .catch((error: any) => {
          assignErrorToInput(form, error?.STATUS);
        })
        .finally(() => setSaving(false));
    }
  };


  return (
    <Drawer
      title={`${titleName}`}
      open={open}
      width={"70%"}
      onClose={drawerClose}
      destroyOnClose
      closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
      footer={[
        <CancelButton key={2} onClick={drawerClose} />,
        <SaveButton
          key={1}
          form="admin-change-password-form"
          disabled={disabled}
          loading={saving}
        />,
      ]}
      {...rest}
    >
      <FormBox
        form={form}
        id={'admin-change-password-form'}
        onFinish={onFinish}
        onValuesChange={validateForm}
      >
        <Row gutter={15}>
          <br />
          <br />
          <Col xs={{ span: 24 }}>
            <b>Change Password:</b>
          </Col>
          <br />
          <br />
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Password
              name="password"
              label="Password"
              placeholder="xxxxxxx"
              rules={rules.password()}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Password
              name="password_confirmation"
              label="Confirm Password"
              placeholder="xxxxxxx"
              rules={rules.confirmPassword()}
            />
          </Col>
        </Row>
      </FormBox>
    </Drawer>
  );
};

export default ChangePasswordDrawer;
